<template>
  <div class="derwick-associates-payments p-3">
    <h4>Derwick Associates payments found in FinCEN Files</h4>
    <p class="mb-0">Amounts related to transactions between 2009 - 2017 flagged as suspicious involving Derwick Associates</p>
    <stacked-bar-chart :data="data" x-axis-tick-format="$," hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">
      Source: FinCEN Files
    </p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'DerwickAssociatesPayments',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Derwick Associates', value: 7571393.16 },
        { label: 'Francisco Convit Guruceaga', value: 6960109.69 },
        { label: 'Alejandro Betancourt', value: 5100980.00 },
        { label: 'Pedro Jose Trebbau', value: 4242800 },
        { label: 'Edgard Romero Lazo', value: 4044386.68 }
      ]
    }
  }
}
</script>
